export const foodTypes = {
     BIRYANI_INCREASE : 'BIRYANI_INCREASE',
     BIRYANI_DECREASE : 'BIRYANI_DECREASE',
     FRIED_RICE_INCREASE : 'FRIED_RICE_INCREASE',
     FRIED_RICE_DECREASE : 'FRIED_RICE_DECREASE',
     VEG_BIRYANI_INCREASE : 'VEG_BIRYANI_INCREASE',
     VEG_BIRYANI_DECREASE : 'VEG_BIRYANI_DECREASE',
    SOUTH_MEALS_INCREASE : 'SOUTH_MEALS_INCREASE',
    SOUTH_MEALS_DECREASE : 'SOUTH_MEALS_DECREASE',
    NORTH_MEALS_INCREASE : 'NORTH_MEALS_INCREASE',
    NORTH_MEALS_DECREASE : 'NORTH_MEALS_DECREASE',
    TANDOORI_CHICKEN_INCREASE : 'TANDOORI_CHICKEN_INCREASE',
    TANDOORI_CHICKEN_DECREASE : 'TANDOORI_CHICKEN_DECREASE',
    GRILL_CHICKEN_INCREASE : 'GRILL_CHICKEN_INCREASE',
    GRILL_CHICKEN_DECREASE : 'GRILL_CHICKEN_DECREASE',
    CLEAR_ALL_FOOD : 'CLEAR_ALL_FOOD'
}